import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="bg-gradient-to-br from-indigo-950 via-primary to-indigo-900 dark:from-gray-900 dark:via-primary dark:to-gray-800 text-white dark:text-white pt-12 pb-6">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16">
      <div className="flex flex-col md:flex-row md:justify-between gap-12 border-b border-white/10 dark:border-white/10 pb-10">
        {/* Brand & Social */}
        <div className="flex-1 min-w-[200px]">
          <Link to="/" className="flex items-center gap-2 mb-4 group">
            <div className="relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-8 h-8 transition-all duration-300 group-hover:text-accent"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M16 8h-6.5a2.5 2.5 0 0 0 0 5h3a2.5 2.5 0 0 1 0 5H6"></path>
                <path d="M12 18v2"></path>
                <path d="M12 4v2"></path>
              </svg>
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-accent rounded-full animate-pulse"></span>
            </div>
            <span className="font-bold text-xl md:text-2xl tracking-tight">
              DigiMoney
              <span className="text-accent"> Bank</span>
            </span>
          </Link>
          <p className="text-white/80 dark:text-white/90 mb-5 max-w-xs">
            Modern banking made simple, secure, and smart. Experience the future
            of finance with DigiMoney Bank.
          </p>
          <div className="flex gap-3">
            <a
              href="/"
              aria-label="Facebook"
              className="w-9 h-9 rounded-full bg-white/10 dark:bg-white/20 flex items-center justify-center hover:bg-accent hover:text-white transition-colors"
            >
              {/* Facebook */}
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </a>
            <a
              href="/"
              aria-label="Twitter"
              className="w-9 h-9 rounded-full bg-white/10 dark:bg-white/20 flex items-center justify-center hover:bg-accent hover:text-white transition-colors"
            >
              {/* Twitter */}
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
            <a
              href="/"
              aria-label="Instagram"
              className="w-9 h-9 rounded-full bg-white/10 dark:bg-white/20 flex items-center justify-center hover:bg-accent hover:text-white transition-colors"
            >
              {/* Instagram */}
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
            <a
              href="/"
              aria-label="YouTube"
              className="w-9 h-9 rounded-full bg-white/10 dark:bg-white/20 flex items-center justify-center hover:bg-accent hover:text-white transition-colors"
            >
              {/* YouTube */}
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="flex-1 min-w-[160px]">
          <h4 className="font-bold mb-4 text-white/90 dark:text-white">
            Quick Links
          </h4>
          <ul className="space-y-2 text-white/80 dark:text-white/90">
            <li>
              <Link
                to="/accounts"
                className="hover:text-accent transition-colors"
              >
                Accounts
              </Link>
            </li>
            <li>
              <Link to="/cards" className="hover:text-accent transition-colors">
                Credit Cards
              </Link>
            </li>
            <li>
              <Link to="/loans" className="hover:text-accent transition-colors">
                Loans
              </Link>
            </li>
            <li>
              <Link
                to="/investments"
                className="hover:text-accent transition-colors"
              >
                Investments
              </Link>
            </li>
            <li>
              <Link
                to="/support"
                className="hover:text-accent transition-colors"
              >
                Support
              </Link>
            </li>
          </ul>
        </div>

        {/* Resources */}
        <div className="flex-1 min-w-[160px]">
          <h4 className="font-bold mb-4 text-white/90 dark:text-white">
            Resources
          </h4>
          <ul className="space-y-2 text-white/80 dark:text-white/90">
            <li>
              <Link
                to="/resources"
                className="hover:text-accent transition-colors"
              >
                Blog & Insights
              </Link>
            </li>
            <li>
              <Link to="/faq" className="hover:text-accent transition-colors">
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/demo" className="hover:text-accent transition-colors">
                Request Demo
              </Link>
            </li>
            <li>
              <Link
                to="/privacy-policy"
                className="hover:text-accent transition-colors"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-accent transition-colors">
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="flex-1 min-w-[200px]">
          <h4 className="font-bold mb-4 text-white/90 dark:text-white">
            Contact Us
          </h4>
          <ul className="space-y-2 text-white/80 dark:text-white/90 text-sm">
            <li>
              <span className="block">152/1, D Block, Shuangliu</span>
              <span className="block">Chengdu, Sichuan, 610000</span>
            </li>
            <li>
              <a
                href="mailto:support@digimoney.com"
                className="hover:text-accent transition-colors"
              >
                support@digimoney.com
              </a>
            </li>
            <li>
              <a
                href="tel:+8618001234567"
                className="hover:text-accent transition-colors"
              >
                +86 1800 123 4567
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="flex flex-col md:flex-row md:justify-between items-center gap-4 pt-8 text-sm text-white/60 dark:text-white/80">
        <div>
          &copy; {new Date().getFullYear()} DigiMoney Bank. All rights reserved.
        </div>
        <div className="flex gap-4">
          <Link
            to="/privacy-policy"
            className="hover:text-accent transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="hidden md:inline">|</span>
          <Link to="/terms" className="hover:text-accent transition-colors">
            Terms
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
